<template>
  <div class="comp-user-field">
    <jw-trigger trigger="click" :show-arrow="true" :popup-visible="data.popupVisible" unmount-on-close>
      <icon-edit @click="openTrigger" />
      <template #content>
        <div class="content-basic">
          <div class="user-title">节点负责人</div>
          <jw-tooltip>
            <template #content>
              <h4>节点负责人与下列角色联动</h4>
            </template>
            <icon-question-circle class="hand" />
          </jw-tooltip>
          <jw-form class="u-form" ref="formRef" label-align="left" :model="data.form" @submit="handleSubmit">
            <template v-for="(item, index) in nodeConfigInfo" :key="index">
              <jw-form-item
                class="user-item"
                auto-label-width
                :title="item.setting.fieldName"
                :label="item.setting.fieldName"
                :field="item.setting?.fieldKey"
                :rules="[
                  {
                    required: item.setting?.isRequired ? true : false,
                    message: $t('该字段必填')
                  }
                ]"
                :validate-trigger="['blur', 'change']"
              >
                <fh-person position="bl" :multiple="item.operation === 'equals' || item.operation === 'not_equals' ? false : true" :maxTagCount="2" :item="item" @cb="getValUser($event, item)"> </fh-person>

                <!-- <xl-user-depart @cb="getValUser($event, item)" :tree="userTree" :isScreen="true" :maxTagCount="2" style="flex: 1" :sub="item"></xl-user-depart> -->
              </jw-form-item>
              <!-- <div class="user-item">
                <div class="user-label"><span v-if="item.setting?.isRequired" class="is-required">*</span>{{ item.setting.fieldName }}:</div>
                <xl-user-depart @cb="getValUser($event, item)" :tree="userTree" :isScreen="true" :maxTagCount="2" style="flex: 1" :sub="item"></xl-user-depart>
              </div> -->
            </template>
            <div class="user-btn">
              <jw-button type="primary" @click="btConfirm" size="small">确认</jw-button>
            </div>
          </jw-form>
        </div>
      </template>
    </jw-trigger>
    <div v-if="showOverlay" class="overlay" @click.stop="hideLay"></div>
  </div>
</template>

<script setup>
// import useEditFields from '@/hooks/edit-field';
// const { editField } = useEditFields();
import { reactive, ref } from 'vue';
import { tools } from '@/utils/tools';
import { publicService } from '@/api/';
import { Message } from '@arco-design/web-vue';
const emits = defineEmits(['cb']);
const props = defineProps({
  detailData: {
    type: [Object],
    default: () => {}
  },
  nodeConfig: {
    type: [Object],
    default: () => {}
  }
});

const data = reactive({
  popupVisible: false,
  form: {}
});

// const userTree = ref({
//   checkDepartment: false,
//   isAll: false
// });
const showOverlay = ref(false);
const formRef = ref();

// const dataInfo = computed(() => props.detailData);
const nodeConfigInfo = ref([]);

const getUserFields = () => {
  if (Array.isArray(props.nodeConfig?.ownerUserFields) && props.nodeConfig?.ownerUserFields?.length) {
    const _nodeInfo = [];
    props.nodeConfig?.ownerUserFields?.forEach((item) => {
      // 修改字段信息
      if (Array.isArray(item.values) && item.values?.length) {
        item.values?.forEach((u) => {
          u.id = u.userId;
          u.avatarOrigin = u.avatar;
        });
        item.userList = item.values;
        item.userDeptIds = item.values?.map((user) => user.id);
      } else {
        item.userList = [];
        item.userDeptIds = [];
      }
      // 设置单选 多选
      if (item?.setting?.fieldExt && tools.isJSON(item?.setting?.fieldExt)) {
        const fieldExt = JSON.parse(item?.setting?.fieldExt);
        // single 0 是多选 1是单选
        if (fieldExt?.single == 1) {
          item.operation = 'equals';
        } else {
          item.operation = '';
        }
      }
      _nodeInfo.push(item);
    });
    nodeConfigInfo.value = _nodeInfo;

    console.log('nodeConfigInfo.value', nodeConfigInfo.value);
  }
};

const handleSubmit = ({ values, errors }) => {
  console.log('values:', values, '\nerrors:', errors);
  if (!errors) {
    showOverlay.value = false;
    data.popupVisible = false;
    saveVal();
  }
};

const btConfirm = () => {
  formRef.value?.handleSubmit();
};

const openTrigger = () => {
  getUserFields();
  if (Array.isArray(nodeConfigInfo.value) && nodeConfigInfo.value?.length) {
    nodeConfigInfo.value?.forEach((item) => {
      data.form[item.setting?.fieldKey] = item?.userList;
    });
  }
  data.popupVisible = true;
  showOverlay.value = true;
};
// 修改节点负责人
const handleOwnerList = async (params) => {
  try {
    const json = await publicService.updateNodeOwners(params);
    if (json && !json.error) {
      Message.success('设置成功');
      emits('cb');
    } else {
      Message.error(json.error?.msg || '失败，请重试!');
    }
  } catch (e) {
    Message.error(e.message || e.statusText || '失败，请重试!');
  }
};
const status = ref(false); //是否改变
const getValUser = (e, item) => {
  //   console.log('getValUser-11', e, item);
  data.form[item.setting?.fieldKey] = e?.userList ? e?.userList : '';
  item.userList = e.userList;
  status.value = true;
};

const hideLay = async () => {
  showOverlay.value = false;
  data.popupVisible = false;
};
// 人员保存
const saveVal = async () => {
  if (Array.isArray(nodeConfigInfo.value) && nodeConfigInfo.value?.length && status.value) {
    const params = [];
    nodeConfigInfo.value?.forEach(async (item) => {
      //  console.log('dataInfo',item, dataInfo.value);
      const userList = item?.userList?.map((user) => user.id)?.filter((id) => id != null);
      const paramsItem = {
        [item.setting.fieldKey]: userList,
        deleteChargePersonList: item?.userDeptIds?.filter((itemId) => !userList.includes(itemId)) // 删除的人
      };
      params.push(paramsItem);
    });
    handleOwnerList({ userFieldOwnerList: params, nodeId: props.nodeConfig.id });
    // console.log('params', params);
  }
};
</script>
<style scoped lang="less">
@import './user-field.less';
</style>
